import React from 'react';

import Logo from '../components/icons/Logo';
import Map from '../components/icons/Map';

import ActionButtonLink from '../components/links/ActionButtonLink';
import Link from '../components/links/Link';
import MailLink from '../components/links/MailLink';

import Container from '../components/blocks/Container';
import ContainerSmall from '../components/blocks/ContainerSmall';
import Cover from '../components/blocks/Cover';
import Section from '../components/blocks/Section';
// import GridBlock from '../components/blocks/GridBlock';
import Blocks from '../components/blocks/Blocks';
import Block from '../components/blocks/Block';
import Flex from '../components/blocks/Flex';

import PageIntro from '../components/headings/PageIntro';
import SectionTitle from '../components/headings/SectionTitle';
import SubTitle from '../components/headings/SubTitle';
import BlockTitle from '../components/headings/BlockTitle';
// import PriceTitle from '../components/headings/PriceTitle';
import FooterTitle from '../components/headings/FooterTitle';

import Text from '../components/text/Text';
// import ActionText from '../components/text/ActionText';
import SmallText from '../components/text/SmallText';
// import SignupForm from '../components/forms/SignupForm';
import BetaSignupForm from '../components/forms/BetaSignupForm';
import PresetPreview from '../components/blocks/PresetPreview';
import Hide from '../components/blocks/Hide';

const IndexPage = () => (
  <div>
    <Cover>
      <Section vertical transparent>
        <Container>
          <Block horizontal>
            <Blocks>
              <ContainerSmall alignLeft="640px">
                <Flex
                  vertical
                  valign="center"
                  height="100%"
                >
                  <Hide breakpoint="min-width: 640px">
                    <Block horizontal>
                      <PageIntro>All of your translation, made easy</PageIntro>
                      <SubTitle alignLeft="640px" white>
                        Optimize, deliver and translate all of your languages,
                        from any source, for faster translated websites and apps.
                      </SubTitle>
                    </Block>
                  </Hide>
                  <Hide breakpoint="max-width: 640px">
                    <PageIntro>All of your translation, made easy</PageIntro>
                    <SubTitle alignLeft="640px" white>
                      Optimize, deliver and translate all of your languages,
                      from any source, for faster translated websites and apps.
                    </SubTitle>
                    <Block center vertical>
                      {/* <SignupForm small inverse /> */}
                      {/* <Block vertical>
                        <Text white>By signing up, you agree to our <HeavyLink
                          white
                          to="/terms"
                        >Terms of Service</HeavyLink>.</Text>
                      </Block> */}
                      <BetaSignupForm small inverse />
                      <Block vertical>
                        <Text white>By signing up, you&apos;ll be first to know
                          when SpaceTranslate is available.</Text>
                      </Block>
                    </Block>
                  </Hide>
                </Flex>
              </ContainerSmall>
              <div>
                <Block vertical height="100%">
                  <PresetPreview url="your-space.spacetranslate.com">
                    <Logo large />
                  </PresetPreview>
                </Block>
              </div>
            </Blocks>
            <Hide breakpoint="min-width: 640px">
              <Block>
                <Flex horizontal halign="center">
                  <ActionButtonLink
                    to="/signup"
                    inverted
                    bold
                  >
                    Get Started Today
                  </ActionButtonLink>
                </Flex>
              </Block>
            </Hide>
          </Block>
        </Container>
      </Section>
    </Cover>
    <Section vertical>
      <Container>
        <SectionTitle>Are you still managing your translations in-house?</SectionTitle>
        <SubTitle>
          Spend your time on features your users love instead.
        </SubTitle>
        <Blocks>
          <Block center>
            <BlockTitle>Speed up development</BlockTitle>
            <Text>Apps and sites need amazing content in many different sizes,
              stop rebuilding the wheel that makes the different sizes, this
              wheel is fast to get started with and got everything you need.</Text>
          </Block>
          <Block center>
            <BlockTitle>Time spent where it matters</BlockTitle>
            <Text>Don&apos;t spend valuable time on building your own translation
              management solution, put it on features your users love and need,
              and get to market faster with your product.</Text>
          </Block>
          <Block center>
            <BlockTitle>Reduce your costs</BlockTitle>
            <Text>Image processing takes a lot of resources, on development, management, hosting and
              maintainence. Simplify your image management and reduce your IT costs.</Text>
          </Block>
        </Blocks>
      </Container>
    </Section>
    <Section vertical>
      <Container>
        <SectionTitle>Boost your translation workflow</SectionTitle>
        <SubTitle>
          Benefits your website and apps can&apos;t function without.
        </SubTitle>
        <Blocks>
          <Block center>
            <BlockTitle>Speed up translation</BlockTitle>
            <Text>A faster translation workflow will get you more languages at less effort
              - all of which will contribute to the success of your business. If
              your site is text-rich, you will need to be extra work in order
              to keep translations up to date.</Text>
          </Block>
          <Block center>
            <BlockTitle>Lightning fast translations</BlockTitle>
            <Text>Each service runs through a redundant 40Gbps network to ensure
              uptime and throughput for non-cached translations.</Text>
          </Block>
          <Block center>
            <BlockTitle>Improve your search ranking</BlockTitle>
            <Text>Since 2010, Google has weighted sites loading speed as
              an important criteria to determine ranking. Faster loading
              sites are more favourable than their slower counterparts.
              We make sure your translations aren&apos;t slow.</Text>
          </Block>
        </Blocks>
      </Container>
    </Section>
    <Section vertical>
      <Container>
        <SectionTitle>Seamlessy translate your languages</SectionTitle>
        <SubTitle>
          Features for control, flexibility, and ease included in all spaces.
        </SubTitle>
      </Container>
    </Section>
    {/* <Section vertical>
      <Container>
        <SectionTitle>Straightforward pricing</SectionTitle>
        <SubTitle>Pricing that fits every project and
          doesn&apos;t run out of hand.</SubTitle>
        <Blocks>
          <GridBlock>
            <PriceTitle>5</PriceTitle>
            <Text>
              <ActionText><strong>20GB</strong> Storage</ActionText>
              <ActionText><strong>5GB</strong> Transfer</ActionText>
              <ActionText><strong>50,000</strong> Transforms</ActionText>
            </Text>
          </GridBlock>
          <GridBlock>
            <PriceTitle>10</PriceTitle>
            <Text>
              <ActionText><strong>40GB</strong> Storage</ActionText>
              <ActionText><strong>10GB</strong> Transfer</ActionText>
              <ActionText><strong>100,000</strong> Transforms</ActionText>
            </Text>
          </GridBlock>
          <GridBlock>
            <PriceTitle>15</PriceTitle>
            <Text>
              <ActionText><strong>80GB</strong> Storage</ActionText>
              <ActionText><strong>15GB</strong> Transfer</ActionText>
              <ActionText><strong>150,000</strong> Transforms</ActionText>
            </Text>
          </GridBlock>
          <GridBlock>
            <PriceTitle>20</PriceTitle>
            <Text>
              <ActionText><strong>100GB</strong> Storage</ActionText>
              <ActionText><strong>20GB</strong> Transfer</ActionText>
              <ActionText><strong>200,000</strong> Transforms</ActionText>
            </Text>
          </GridBlock>
          <GridBlock active>
            <PriceTitle>40</PriceTitle>
            <Text>
              <ActionText><strong>200GB</strong> Storage</ActionText>
              <ActionText><strong>40GB</strong> Transfer</ActionText>
              <ActionText><strong>400,000</strong> Transforms</ActionText>
            </Text>
            <ActionButton fluid>Get Started</ActionButton>
          </GridBlock>
          <GridBlock>
            <PriceTitle>80</PriceTitle>
            <Text>
              <ActionText><strong>400GB</strong> Storage</ActionText>
              <ActionText><strong>80GB</strong> Transfer</ActionText>
              <ActionText><strong>800,000</strong> Transforms</ActionText>
            </Text>
          </GridBlock>
          <GridBlock>
            <PriceTitle>100</PriceTitle>
            <Text>
              <ActionText><strong>500GB</strong> Storage</ActionText>
              <ActionText><strong>100GB</strong> Transfer</ActionText>
              <ActionText><strong>1,000,000</strong> Transforms</ActionText>
            </Text>
          </GridBlock>
          <GridBlock>
            <PriceTitle>250</PriceTitle>
            <Text>
              <ActionText><strong>1TB</strong> Storage</ActionText>
              <ActionText><strong>250GB</strong> Transfer</ActionText>
              <ActionText><strong>2,500,000</strong> Transforms</ActionText>
            </Text>
          </GridBlock>
          <GridBlock>
            <PriceTitle>500</PriceTitle>
            <Text>
              <ActionText><strong>2TB</strong> Storage</ActionText>
              <ActionText><strong>500GB</strong> Transfer</ActionText>
              <ActionText><strong>5,000,000</strong> Transforms</ActionText>
            </Text>
          </GridBlock>
        </Blocks>
      </Container>
    </Section> */}
    <Section vertical>
      <SectionTitle>Global infrastructure on demand</SectionTitle>
      <SubTitle>Your translations delivered through our cloud CDN from all over the
        world.</SubTitle>
      <Container>
        <Block vertical>
          <Map />
        </Block>
      </Container>
      <ContainerSmall>
        <ActionButtonLink to="/signup">Create Space</ActionButtonLink>
      </ContainerSmall>
    </Section>
    {/* <Section>
      <SectionTitle>Join other teams on SpaceTranslate</SectionTitle>
      <Block>
        <ActionText>CUSTOMERS LOGOS</ActionText>
      </Block>
      <ContainerSmall>
        <ActionButton>Create Team</ActionButton>
      </ContainerSmall>
    </Section> */}
    <Section vertical satinblack>
      <Container>
        <Flex wrap>
          <Block left="0" flex={'auto 0 0'}>
            <Logo />
          </Block>
          <Block flex={2} minWidth={320}>
            <FooterTitle>About</FooterTitle>
            <SmallText>
              SpaceTranslate is dedicated to making applications and websites
              translated much faster and with less work than ever before.
              We strive to work with thousands of companies and open source
              contributors around the world to build the product, libraries, and
              resources teams need to confidently minimize translation work in
              production.
            </SmallText>
          </Block>
          <Block flex={1} minWidth={200}>
            <FooterTitle>SpaceTranslate</FooterTitle>
            <SmallText>
              <ul>
                <li>
                  <MailLink email="info@spacetranslate.com">info@spacetranslate.com</MailLink>
                </li>
                <li>
                  Copyright © 2018
                </li>
              </ul>
            </SmallText>
          </Block>
          <Block flex={1} minWidth={200}>
            <FooterTitle>Help</FooterTitle>
            <SmallText>
              <ul>
                <li>
                  <Link to="/terms">Terms of Service</Link>
                </li>
                <li>
                  <Link to="/privacy">Privacy</Link>
                </li>
              </ul>
            </SmallText>
          </Block>
        </Flex>
      </Container>
    </Section>
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js